<template>
  <div class="quiz-point-config">
    <div class="horizontal layout center config-point">
      <div class="mr-2 point-config-input">
        <span class="point-config-text">
          {{ $i18nPresenter.t('Max:') }}
        </span>
        <aha-input
          type="number"
          class="absolute top-0 right-0 point-input"
          :error="isMaxPointError"
          v-model="slideActive.maxPoint"
          @input="onChangeValue()"
        >
        </aha-input>
      </div>
      <div class="point-config-input">
        <span
          class="point-config-text"
          :class="{'disabled': !slideActive.fastAnswerGetMorePoint}"
        >
          {{ $i18nPresenter.t('Min:') }}
        </span>
        <aha-input
          type="number"
          class="absolute top-0 right-0 point-input"
          :error="isMinPointError"
          :disabled="!slideActive.fastAnswerGetMorePoint"
          :class="{'disabled': !slideActive.fastAnswerGetMorePoint}"
          v-model="slideActive.minPoint"
          @input="onChangeValue()"
        >
        </aha-input>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Config from '@/config'
import Socket from '@/socket'

export default {
  data() {
    return {
      isMaxPointError: false,
      isMinPointError: false,
    }
  },
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    fastAnswerHasMaxPointSmallerThanMinPoint() {
      return this.slideActive.fastAnswerGetMorePoint &&
      this.slideActive.maxPoint < this.slideActive.minPoint
    },
  },
  watch: {
    '$store.state.slideActive.fastAnswerGetMorePoint': function () {
      if (this.fastAnswerHasMaxPointSmallerThanMinPoint) {
        this.updateSlideActiveAction({
          minPoint: this.slideActive.maxPoint,
        })
      }

      this.onChangeValue()
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncPresentationAction']),
    onChangeValue() {
      if (this.slideActive.maxPoint && this.slideActive.maxPoint < 0) {
        this.updateSlideActiveAction({ maxPoint: 0 })
      }

      if (this.slideActive.minPoint && this.slideActive.minPoint < 0) {
        this.updateSlideActiveAction({ minPoint: 0 })
      }

      if (!this.slideActive.maxPoint) {
        this.isMaxPointError = true
        return
      }

      if (this.fastAnswerHasMaxPointSmallerThanMinPoint) {
        this.isMaxPointError = true
        return
      }

      this.isMaxPointError = false
      if (!this.slideActive.minPoint && this.slideActive.minPoint !== 0) {
        this.isMinPointError = true
        return
      }

      let maxPoint = parseInt(this.slideActive.maxPoint, 10)
      let minPoint = parseInt(this.slideActive.minPoint, 10)

      maxPoint = Math.min(1000, maxPoint)
      minPoint = Math.min(1000, minPoint)
      minPoint = Math.max(0, minPoint)

      this.updateSlideActiveAction({ maxPoint, minPoint })
      this._updateSlide({ minPoint, maxPoint })
      this.isMinPointError = false
    },

    async _updateSlide(payload) {
      this.setSyncPresentationAction(1)
      const slideId = this.slideActive.id

      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      payload.presenting = this.$store.getters.isPresenting || this.isBackstage

      try {
        await this.$http.put(Config.api.updateSlide + slideId, payload)
        this.setSyncPresentationAction(2)
      } catch {
        this.setSyncPresentationAction(3)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/mixins.scss";
.config-point {
  input:not(:last-child) {
    width: 80px;
    margin-right: 20px;

    &.error {
      border-color: $danger-color;
      color: $danger-color;
    }
  }

  .point-config-input {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    .text-base-70.disabled {
      color: #a5a5a5;
      opacity: 1;
    }
    .point-config-text {
      @apply absolute top-2.5 left-2 text-base-70;
      z-index: 6;
    }
  }

  .label-quiz-point {
    margin-right: 10px;;
  }
}
.point-input {
  z-index: 5;
  & ::v-deep .aha-input {
    padding-left: 42px;
    width: 112px;
    padding-right: 2px;
  }
  @media (max-width: $xs-device-width) {
    & ::v-deep .aha-input {
      width: 95px;
    }
  }
}
</style>
